const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year', label: '대상년월', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
      {
        'component': 'search-month', label: '월', value: 'month', query: {'y_m': 'month'},
        options: {
          default: '',
          lastLabel: true,
          useAll: true,
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['재해형태', '작성일']}
      },

    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let dateTarget = "body.headerDate";
    let dateBegin = `${new Date().getFullYear()}-01-01`;
    let dateEnd = `${new Date().getFullYear()}-12-31`;
    if (search.year) {
      if (search.month) {
        dateBegin = `${search.year}-${search.month}-01`;
        if (`${search.month}` === '12') {
          dateEnd = new Date(`${Number(search.year) + 1}-01-01`).addDays(-1)
        } else {
          dateEnd = new Date(`${search.year}-${Number(search.month) + 1}-01`).addDays(-1)
        }
        dateEnd = new Date(dateEnd).format("yyyy-MM-dd")
      } else {
        dateBegin = `${search.year}-01-01`;
        dateEnd = `${search.year}-12-31`;
      }
    }

    conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "사업장명",
        "key": "content$body.stdInfo.field_name"
      },
      {
        "name": "대상연월",
        "key": "content$body.headerDate"
      },
      {
        "name": "소속명",
        "key": "content$body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "content$body.stdInfo.section"
      },
      {
        "name": "작성자",
        "key": "content$body.stdInfo.writer_name"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).headerDateString // 대상연월
      case 2: return func.getContent(value).stdInfo.department // 소속명
      case 3: return func.getContent(value).stdInfo.section // 부서명
      case 4: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
